<template>
  <van-radio-group v-model="cart_goods_addons[strName]" checked-color="#ee0a24">
    <van-cell-group>
      <!-- 属性值列表 -->
      <van-cell v-for="(item, key) in arrItems" :key="key" :title="item.title" :class="'xxxxxxxx'" :clickable="checked == false" @click="radioSelect(item,key)">
        <div class="attr-price">RM {{item.price}}</div>
        <van-radio :disabled="checked == true" slot="right-icon" :name="item.id" />
      </van-cell>
    </van-cell-group>
  </van-radio-group>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'cart',
  props: {
    arrItems: {
      type: Array
    },
    strName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      checked: false,
      curAttr: {},
      aint: 0,
      old_cart_goods_addons: {}, //保存旧的规格选项值
      aitm: '', // 点击后保存的值放这里
    }
  },
  computed: {
    ...mapGetters([
      'cart_goods_addons'
    ])
  },
  created() {
    this.old_cart_goods_addons['name'] = this.strName
    this.old_cart_goods_addons['value'] = this.cart_goods_addons[this.strName]
    console.log('this.old_cart_goods_addons ',this.old_cart_goods_addons)
    this.checkradioSelected()
  },
  methods: {
    ...mapActions({
      setRadioAddons: 'shoppping_cart/settingRadioGoodsAddons'
    }),
    checkradioSelected(){
      if (this.old_cart_goods_addons['value'] == ''){
        for (let v in this.arrItems){
          if (this.arrItems[v].is_selected == 1){
            if (this.checked == false){
              this.checked = true
              this.chooseAttr(this.arrItems[v],v)
            }
          }
        }
      } else {
        for (let v in this.arrItems){
          if (this.arrItems[v].is_selected == 1){
            if (this.checked == false){
              if (this.old_cart_goods_addons['value'] != this.arrItems[v].id){
                this.chooseAttr(this.arrItems[v],v)
              } else {
                this.checked = true
              }
            }
          }
        }
      }
    },
    radioSelect(item,key){
      if (item.is_selected == 0){
        if (this.checked == false){
          this.chooseAttr(item,key)
        }
      }
    },
    isNullOrEmpty(param) {
      if (param == null || param === undefined || param === '') {
        return true
      }
      return false
    },
    chooseAttr(item, key) {
      const todo = () => {
        let todoVar = this.cart_goods_addons
        if (this.aint === 0 && todoVar[this.strName] > 0) {
          if (this.old_cart_goods_addons.value === todoVar[this.strName]) {
            if (item.id === this.old_cart_goods_addons.value) {
              todoVar[this.strName] = ''
            } else {
              todoVar[this.strName] = item.id
            }
          } else {
            todoVar[this.strName] = item.id
          }
          this.aitm = todoVar[this.strName]
        } else {
          this.aitm = this.aitm === item.id ? '' : item.id
          todoVar[this.strName] = this.aitm
        }
        return todoVar
      }
      const finalAddos = todo()
      this.aint++
      this.setRadioAddons(finalAddos)

      this.curAttr[item.start] = item.title
      this.curAttr["optionid"] = item.id
      this.curAttr["price"] = item.price
      if (this.cart_goods_addons[this.strName] === '') {
        this.$emit('evtChooseAttr', this.curAttr, this.strName, false)
      } else {
        this.$emit('evtChooseAttr', this.curAttr, this.strName, true)
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>